import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/worker_housing_actions";
import cellGenerator from "./columnUtils";

const worker_housing_columns = (isSubaccount) => [
  {
    id: "profile-name",
    Header: "Profile Name",
    accessor: "WorkerHousingFormData.new_profile_worker_housing_profile_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Type of Housing",
    accessor:
      "WorkerHousingFormData.new_profile_worker_housing_type_of_housing",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "State",
    accessor:
      "WorkerHousingFormData.new_profile_worker_housing_physical_location_state",
    Cell: (props) => cellGenerator(props),
    fixedWidth: 220,
  },
  {
    Header: "County",
    accessor:
      "WorkerHousingFormData.new_profile_worker_housing_physical_location_county.label",
    Cell: (props) => cellGenerator(props),
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("worker-housing", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default worker_housing_columns;
